import { notification } from "antd";
import { useFormContext } from "react-hook-form";
import { useCoordinator } from "@/shared/lib/hooks";
import { NOTIFICATION_MESSAGES } from "@/shared/utils";
import { useReturnTitleJournal } from "../mutate-hooks/use-return-title-journal";
import { useRevokeTitleJournal } from "../mutate-hooks/use-revoke-title-journal";

interface IUseRevokeTitleModal {
  setIsLoading?: (isLoading: boolean) => void;
  handleClear: () => void;
}

export const useRevokeTitleModal = ({
  setIsLoading,
  handleClear,
}: IUseRevokeTitleModal) => {
  const { titleId } = useCoordinator();
  const { mutate: revokeTitle } = useRevokeTitleJournal({ titleId });
  const { mutate: returnTitle } = useReturnTitleJournal({ titleId });
  const { getValues } = useFormContext(); // ✅ заменили watch на getValues

  const handleRevoke = async () => {
    const comment = getValues("comment");

    if (!comment) {
      notification.warning({
        message: NOTIFICATION_MESSAGES.TITLE_COMMENT_REQUIRED, // "Требуется комментарий"
        description: NOTIFICATION_MESSAGES.TITLE_REVOKE_COMMENT_REQUIRED_DESC, // "Пожалуйста, укажите причину отзыва титульного листа."
        placement: "topRight",
      });
      return;
    }

    setIsLoading?.(true);

    revokeTitle(
      { comment, skipInvalidate: true },
      {
        onSuccess: () => {
          returnTitle({
            onSuccess: () => {
              notification.success({
                message: NOTIFICATION_MESSAGES.SUCCESS, // "Успешно"
                description: NOTIFICATION_MESSAGES.TITLE_REVOKED_DESC, // "Титульный лист отозван"
                placement: "topRight",
              });
              handleClear();
              setIsLoading?.(false);
            },
            onError: () => {
              notification.warning({
                message: NOTIFICATION_MESSAGES.TITLE_REVOKED_DESC, // "Титульный лист отозван"
                description: NOTIFICATION_MESSAGES.TITLE_REVOKED_RETURN_WARNING_DESC, // "Не удалось автоматически вернуть документ в работу. Нажмите «Вернуть в работу»."
                placement: "topRight",
              });
              handleClear();
              setIsLoading?.(false);
            },
          });
        },
        onError: () => {
          notification.error({
            message: NOTIFICATION_MESSAGES.ERROR, // "Ошибка"
            description: NOTIFICATION_MESSAGES.TITLE_REVOKE_FAILED_DESC, // "Не удалось отозвать титульный лист"
            placement: "topRight",
          });
          setIsLoading?.(false);
        },
      },
    );
  };

  return { handleRevoke };
};
